<template>
    <SOSlotBase :bg-grey="true">
        <template v-slot:title-bar>
            <SOTitleBar
                :page-title="pageSetting.title"
                :type="'close'"
                :show-delete="true"
                @back="back"
                @delete="doDeleteTemplate"
            />
        </template>
        <template v-slot:content>
            <div class="p-x-20 p-y-16">
                <SOInputRegular
                    :title="'Nama template'"
                    :autocomplete="'off'"
                    :value="detailTemplate.nama"
                    :placeholder="'Nama template'"
                    :required="true"
                    @input="inputNamaTemplate"
                />
            </div>
            <div
                class="f-regular f-14 f-c-blue p-x-20 p-d-16"
                @click="$router.push({ name: 'wa_blast.template-pesan.edit.panduan' })"
            >
                Lihat panduan penuliasan
            </div>

            <div class="p-x-12">
                <SOInputWysiwyg
                    :default-content="detailTemplate.template"
                    :saving-update="saveTemplate"
                    :category="'blast'"
                />
            </div>

            <div class="p-x-20 p-y-16 f-regular f-14 f-c-midgrey text-center">Terakhir diubah {{ lastUpdate }}</div>
        </template>
    </SOSlotBase>
</template>

<script>
import { moduleName } from "./../store/state";
import { mapGetters, mapActions } from "vuex";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputWysiwyg from "@/so-components/global/input/SOInputWysiwyg";
import resulter from "@/store/utils/resulter";

export default {
    name: "WABlastTemplateEdit",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOInputRegular,
        SOInputWysiwyg,
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            detailTemplate: "detailTemplate",
        }),
        lastUpdate() {
            return this.$moment(this.detailTemplate.updated_at).format("DD MMM YYYY HH:mm");
        },
    },
    data() {
        return {
            pageSetting: {
                title: "Ubah template WA Blast",
            },
            id: "",
            nama: "",
        };
    },
    mounted() {
        this.id = this.$route.params.id;
        this.fetchDetailTemplate(this.id);
    },
    methods: {
        ...mapActions({
            fetchDetailTemplate: `${moduleName}/fetchDetailTemplate`,
            updateTemplateBlast: `${moduleName}/updateTemplateBlast`,
            deleteTemplate: `${moduleName}/deleteTemplate`,
            fetchListTemplate: `${moduleName}/fetchListTemplate`,
            resetListTemplate: `${moduleName}/resetListTemplate`,
            setFetching: `${moduleName}/setFetching`,
        }),
        back() {
            this.$router.back();
        },
        inputNamaTemplate(val) {
            this.nama = val;
            $("#save-template").prop("disabled", false);
        },
        saveTemplate(val) {
            let form = new FormData();
            form.append("nama", this.nama);
            form.append("template", val);
            let payload = {
                id: this.id,
                form: form,
            };
            this.updateTemplateBlast(payload)
                .then((response) => {
                    let { code, status, msg, data } = response.data;

                    if (status && code === 200) {
                        this.$toast.success(msg);
                        this.resetListTemplate();
                        this.back();
                        this.setFetching(false);
                    } else {
                        this.setFetching(false);
                        this.setResponse(resulter.errorResult(msg));
                        this.$toast.error(msg);
                    }
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                    this.setResponse(resulter.errorResult(e));
                });
        },
        doDeleteTemplate() {
            this.$router.push({
                name: "wa_blast.template-pesan.edit.confirm-delete",
                params: {
                    id: this.id,
                },
                query: {
                    list: true,
                    templateName: this.detailTemplate.nama,
                },
            });

            // this.deleteTemplate(this.id)
            //     .then((response) => {
            //         let {code, status, msg, data} = response.data;
            //
            //         if (status && code === 200) {
            //             this.$toast.success(msg);
            //             this.resetListTemplate()
            //             this.fetchListTemplate()
            //             this.$router.go(-2)
            //         } else {
            //             this.setResponse(resulter.errorResult(msg));
            //             this.$toast.error(msg);
            //         }
            //     })
            //     .catch((e) => {
            //         this.setFetching(false);
            //         this.$toast.error(e);
            //         this.setResponse(resulter.errorResult(e));
            //     });
        },
    },
};
</script>
